import NumberPad from './NumberPad.component';

export * from './NumberPad.component';
export default NumberPad;
